export default function Trust() {
  const trustPoints = [
    {
      icon: 'ri-camera-line',
      title: 'Preuves Visuelles',
      description: 'Photos et vidéos après chaque intervention'
    },
    {
      icon: 'ri-file-chart-line',
      title: 'Reporting Mensuel',
      description: 'Rapports détaillés et synthèse financière'
    },
    {
      icon: 'ri-message-3-line',
      title: 'Communication Régulière',
      description: 'Disponibilité et réactivité garanties'
    }
  ];

  return (
    <section id="transparence" className="py-20 md:py-32 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-serif text-[#1A3B5C] mb-8">
            (Notre Engagement Transparence)
          </h2>
        </div>

        <div className="bg-[#F8F9FA] rounded-3xl p-12 md:p-16 relative">
          <div className="absolute top-8 left-8 flex items-center space-x-2 bg-gray-900 px-4 py-2 rounded-full">
            <i className="ri-star-fill text-[#C9A961]"></i>
            <span className="text-white font-semibold text-sm">Charte Qualité AMD</span>
          </div>

          <div className="mt-12">
            <div className="relative">
              <div className="absolute -top-8 -left-4 text-[#C9A961] opacity-20 text-9xl font-serif leading-none">"</div>
              <p className="text-2xl md:text-3xl text-gray-700 font-serif italic leading-relaxed relative z-10">
                La confiance se construit sur la transparence. C'est pourquoi nous documentons chaque intervention avec des preuves visuelles et des rapports détaillés. Vous savez toujours ce qui se passe dans votre propriété.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mt-12">
            {trustPoints.map((point, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                  <i className={`${point.icon} text-[#C9A961] text-5xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#1A3B5C] mb-2">
                  {point.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {point.description}
                </p>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-12">
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-[#1A3B5C] text-white px-6 py-3 rounded-lg hover:bg-[#2A4B6C] transition-all duration-300 font-semibold flex items-center justify-center space-x-2 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-download-line"></i>
              <span>Voir Exemple Rapport</span>
            </button>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="border-2 border-[#1A3B5C] text-[#1A3B5C] px-6 py-3 rounded-lg hover:bg-[#1A3B5C] hover:text-white transition-all duration-300 font-semibold flex items-center justify-center space-x-2 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shield-check-line"></i>
              <span>Télécharger Charte</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
